import { useEffect, useRef, useState } from 'react';
import { displayBalance } from '../utils/balanceDisplay';

export default function BalanceSum({ amount, hidden, className = '', faderHeight = 16 }) {
  const text = displayBalance(amount, hidden);
  const shownRef = useRef(text);
  const [shown, setShown] = useState(text);
  const [leaving, setLeaving] = useState(null);
  const [flash, setFlash] = useState(null);
  const prevAmount = useRef(amount);

  useEffect(() => {
    const prevText = shownRef.current;
    if (text === prevText) {
      prevAmount.current = amount;
      return;
    }

    const prev = prevAmount.current;
    const amountChanged = !hidden && Number(prev) !== Number(amount);

    setLeaving(prevText);
    setShown(text);
    shownRef.current = text;
    prevAmount.current = amount;

    if (amountChanged) {
      setFlash(Number(amount) > Number(prev) ? 'increase' : 'decrease');
      const timer = window.setTimeout(() => {
        setLeaving(null);
        setFlash(null);
      }, 3200);
      return () => window.clearTimeout(timer);
    }

    const timer = window.setTimeout(() => setLeaving(null), 350);
    return () => window.clearTimeout(timer);
  }, [amount, hidden, text]);

  return (
    <span className={`balance-sum${flash ? ` balance-sum--${flash}` : ''}${className ? ` ${className}` : ''}`}>
      <span className="balance-sum__fader" style={{ height: faderHeight }}>
        {leaving && (
          <span key={`leave-${leaving}`} className="balance-sum__clone balance-sum__clone--leave" aria-hidden="true">
            {leaving}
          </span>
        )}
        <span key={`enter-${shown}`} className={`balance-sum__current${leaving ? ' balance-sum__current--enter' : ''}`}>
          <span>{shown}</span>
        </span>
      </span>
    </span>
  );
}
